<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Importar Projeto'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-space-between>
                  <v-flex xs9>
                    <v-text-field label='Registro do projeto no SIEX' v-model="pesquisa.registroSIEX" required
                      :rules="regrasBasicas" max-height="400">
                    </v-text-field>
                  </v-flex>

                  <v-btn color="primary" text @click="pesquisarProjetoSIEX">Pesquisar</v-btn>
                </v-layout>

                <br><br>

                <div v-show="projetoSIEX && projetoSIEX.titulo">
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field readonly label="Título" :value="this.projetoSIEX.titulo"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row justify-space-between>
                    <v-flex xs6>
                      <v-text-field readonly label="Classificação Primária"
                        :value="this.projetoSIEX.classificacaoPrimaria.descricao"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field readonly label="Classificação Secundária"
                        :value="this.projetoSIEX.classificacaoSecundaria.descricao"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row justify-space-between>
                    <v-flex xs6>
                      <v-text-field readonly label="Data de início"
                        :value="this.projetoSIEX.dataInicio || '-'"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field readonly label="Data de conclusão"
                        :value="this.projetoSIEX.dataConclusao || '-'"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>
                    <v-flex xs11 sm5>
                      <v-select label='Tipo de público-alvo' :items="listaTipoPublico" v-model="projetoSIEX.tipoPublico"
                        item-text="descricao" item-value="id" prepend-icon="dashboard" max-height="400" return-object
                        required autocomplete :rules="regrasBasicas">
                      </v-select>
                    </v-flex>
                    <v-flex xs11 sm5>
                      <v-text-field label='Público-alvo estimado' v-model="projetoSIEX.publicoAlvo" mask='#########'
                        required :rules="regrasBasicas" max-height="20">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs11 sm5
                      v-if="projetoSIEX.classificacaoSecundaria && (projetoSIEX.classificacaoSecundaria.id === 39729 || projetoSIEX.classificacaoSecundaria.id === 44194 || projetoSIEX.classificacaoSecundaria.id === 44195)">
                      <v-text-field label='Carga horária' v-model="projetoSIEX.cargaHoraria" required
                        :rules="regrasBasicas" max-height="20">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <p class="mt-3"></p>

                  <v-layout row justify-space-between>
                    <v-flex xs11 sm2>
                      <v-text-field label='Palavra-chave 1' v-model="projetoSIEX.palavraChave01" required
                        :rules="regrasBasicas" max-height="400">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 sm2>
                      <v-text-field label='Palavra-chave 2' v-model="projetoSIEX.palavraChave02" required
                        :rules="regrasBasicas" max-height="400">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 sm2>
                      <v-text-field label='Palavra-chave 3' v-model="projetoSIEX.palavraChave03" required
                        :rules="regrasBasicas" max-height="400">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 sm2>
                      <v-text-field label='Palavra-chave 4' v-model="projetoSIEX.palavraChave04" max-height="400">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <p class="mt-3"></p>

                  <v-layout row justify-space-between>
                    <v-flex xs12>
                      <c-textarea label="Resumo" v-model="projetoSIEX.resumo" required :rules="resumoRules" :rows="3"
                        :auto-grow="true" multi-line counter="1000">
                      </c-textarea>
                    </v-flex>
                  </v-layout>

                </div>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="importarProjetoSIEX" :disabled="!formularioValido">Importar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import DataMenu from '@/components/c-date-menu'
import TextArea from '@/components/c-textarea'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    formularioValido: false,
    dates: dates,
    listaTipoPublico: [],
    projetoSIEX: {
      classificacoesPrimariaSecundaria: [{}, {}]
    },
    pesquisa: {
      registroSIEX: ''
    },
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ],
    resumoRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres'
    ],
    assuntoSummaryRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
    ],
    search: null,
    sortBy: 'dtCriacao',
    sortDesc: true,
    itemsPerPage: 25,
    opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
    headers: [
      { text: 'Número', align: 'center', value: 'idProjeto' },
      { text: 'Título', align: 'center', value: 'titulo' },
      { text: 'Classificação primária', align: 'center', value: 'classificacaoPrimaria.descricao' },
      { text: 'Classificação secundária', align: 'center', value: 'classificacaoSecundaria.descricao' },
      { text: 'Situação', align: 'center', value: 'situacao.descricao' },
      { text: 'Início', align: 'center', value: 'dataCriacao' }
    ]
  }),
  computed: {
    ...mapGetters('autuacao', [
      'listaTipoDocumento',
      'tipoDocumento',
      'listaUnidadeProcedencia',
      'unidadeProcedencia',
      'listaTipoInteressado',
      'tipoInteressado',
      'listaEntidadeInteressada',
      'entidadeInteressada',
      'assunto'
    ]),
    entidadeInteressadaComCodigo: function () {
      return (this.entidadeInteressada.codigo && this.entidadeInteressada.nome) ? ('[' + this.entidadeInteressada.codigo + '] ' + this.entidadeInteressada.nome) : null
    },
    concatenatedSubject: function () {
      return (this.assunto.codigo && this.assunto.descricao) ? ('[' + this.assunto.codigo + '] ' + this.assunto.descricao) : null
    },
    temVinculo: function () {
      if (this.projeto && this.projeto.classificacaoSecundaria) {
        return this.projeto.classificacaoSecundaria.id !== 39733
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate: function (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    pesquisarProjetoSIEX: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjetoSIEX(this.pesquisa.registroSIEX)
        .then(response => {
          this.projetoSIEX = response.data
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
        })
    },
    importarProjetoSIEX: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Importando projeto.' })
      projetos.postImportarProjetoSIEX(this.pesquisa.registroSIEX, this.projetoSIEX)
        .then(response => {
          alert('Atenção! Serão importados apenas os dados de identificação da ação de extensão. Os demais campos deverão ser preenchidos pelo coordenador. Após preenchimento, clicar no botão "concluir importação".')
          this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem })
          let link = response.body.link
          let idProjetoAux = link.split('/')[5]
          console.log('id:')
          console.log(idProjetoAux)
          this.$router.push({ name: 'EditarClassificacao', params: { idProjeto: idProjetoAux } })
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Importando projeto.' })
        })
    },
    opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
      projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
        })
    }
  },
  mounted: function () {
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico')
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip,
    'c-date-menu': DataMenu,
    'c-textarea': TextArea
  }
}
</script>

<style lang="css">
.menu {
  display: block !important;
}

.no-resize div textarea {
  resize: none;
}

.input-group__icon-cb {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// importar-projeto.vue?6c53694b